import { Button, Dialog, DialogContent, Grid, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { CloseIconButton, getManagerSearchParams, isMobileApp, sendDataToIframe, sendDataToMobileApp } from "../Utilities";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useKeycloak } from "../Keycloak";
import { Fragment, useState } from "react";

export default function ArrowNavigation({ children, invertColors }) {

    const { t } = useTranslation()
    const { isSingleProject, isManager } = getManagerSearchParams()
    const { doLogout } = useKeycloak()

    const [openDialog, setOpenDialog] = useState(false)

    const handleHome = () => {
        if (isManager && !isSingleProject) {
            sendDataToIframe({ type: "goHome" })
        } else if (isManager && isSingleProject) {
            sendDataToIframe({ type: "goHomeAndLogout" })
            isMobileApp && sendDataToMobileApp({ type: "logout" }) // only to go back to home screen in mobile app (no logout logic)
        } else {
            doLogout() // only here because login was handled by portal itself instead via manager
            isMobileApp && sendDataToMobileApp({ type: "logout" })
        }
    }

    const handleOpenDialog = () => setOpenDialog(true)
    const handleCloseDialog = () => setOpenDialog(false)

    const buttonStyle = { 
        width: 100, 
        mr: 1, 
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    }

    return (
        <Fragment>
            <Stack direction="row" sx={{ flexGrow: 1, minWidth: 0 }}>

                <Tooltip 
                    title={t("actions.home")}
                    arrow
                >
                    <IconButton
                        sx={{ padding: "0 0 1px 0", color: invertColors ? 'white' : 'primary.main' }}
                        onClick={handleOpenDialog}
                    >
                        <ArrowBackIos sx={{ fontSize: "1.2rem", mr: -0.75 }} />
                        <ArrowBackIos sx={{ fontSize: "1.2rem", ml: -0.75 }} />
                    </IconButton>
                </Tooltip>

                {isManager && !isSingleProject && (
                    <Tooltip 
                        title={t("actions.previous")}
                        arrow
                    >
                        <IconButton
                            sx={{ padding: "0 0 1px 4px", color: invertColors ? 'white' : 'primary.main' }}
                            onClick={() => sendDataToIframe({ type: "goPrevious" })}
                        >
                            <ArrowBackIos sx={{ fontSize: "1.2rem" }} />
                        </IconButton>
                    </Tooltip>
                )}
                
                {children}
                
                {isManager && !isSingleProject && (
                    <Tooltip
                        title={t("actions.next")}
                        arrow
                    >
                        <IconButton
                            sx={{ padding: "0 8px 1px 6px", color: invertColors ? 'white' : 'primary.main' }}
                            onClick={() => sendDataToIframe({ type: "goNext" })}
                        >
                            <ArrowForwardIos sx={{ fontSize: "1.2rem" }} />
                        </IconButton>
                    </Tooltip>
                )}

            </Stack>
            
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-describedby="alert-dialog-description"
            >
                <CloseIconButton onClick={handleCloseDialog} />

                <DialogContent sx={{ p: 2 }}>
                    <Stack spacing={2} alignItems="center">
                        
                        <Typography sx={{ fontSize: '1rem', userSelect: "none" }}>
                            {t("actions.exit")}
                        </Typography>

                        <Grid 
                            item 
                            xs={12}
                            sx={{
                                display: 'flex', 
                                flexDirection: 'row', 
                                justifyContent: 'space-between'
                            }}
                        >
                            <Button 
                                variant="outlined"
                                sx={{ ...buttonStyle }}
                                onClick={handleCloseDialog}
                            >
                                {t("actions.cancel")}
                            </Button>

                            <Button 
                                variant="outlined"
                                sx={{ ...buttonStyle, mr: 0 }}
                                onClick={handleHome}
                                autoFocus
                            >
                                {t("actions.ok")}
                            </Button>
                        </Grid>

                    </Stack>
                </DialogContent>
            </Dialog>
        </Fragment>
    )
}